export default "/images/SL_arriere.png?0a08c42175d218ab66ebe44c7e6447a9";